import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5218e28a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stake-confirm-validators" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Validators", -1))

import { PropType } from "vue";
import StakeConfirmValidatorItem from "./stake-confirm-validator-item.vue";
import { Validator } from "@/types/staking";


export default /*#__PURE__*/_defineComponent({
  __name: 'stake-confirm-validators',
  props: {
  amountToStake: { type: Number, default: 0 },
  validators: {
    type: Object as PropType<Array<Validator>>,
    default: () => {
      return [];
    },
  },
  yield: { type: Number, default: 0 },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.validators, (item, index) => {
      return (_openBlock(), _createBlock(StakeConfirmValidatorItem, {
        key: index,
        validator: item
      }, null, 8, ["validator"]))
    }), 128))
  ]))
}
}

})